import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";

const inr = (n) => `₹${Number(n || 0).toLocaleString("en-IN", { maximumFractionDigits: 2 })}`;
const Row = ({ k, v, id, bold }) => (
  <div className="flex justify-between gap-4"><span className="text-slate-500">{k}</span><span data-testid={id} className={bold ? "font-semibold text-slate-900" : "text-slate-800"}>{v}</span></div>
);

export function PlanChangeDialog({ plan, interval, busy, onCancel, onPay }) {
  const { data: q, isLoading, error } = useQuery({
    queryKey: ["plan-quote", plan.code, interval],
    queryFn: async () => (await api.get(`/saas/plan-change/quote?plan_code=${plan.code}&billing_interval=${interval}`)).data,
  });
  return (
    <Dialog open onOpenChange={() => !busy && onCancel()}>
      <DialogContent className="bg-white max-w-md" data-testid="saas-pay-modal">
        <DialogHeader><DialogTitle className="font-display">Confirm plan change</DialogTitle></DialogHeader>
        {isLoading ? <p className="text-sm text-slate-400">Calculating…</p> : error ? <p className="text-sm text-rose-600" data-testid="quote-error">Price unavailable for this billing period.</p> : (
          <div className="space-y-2 text-sm" data-testid="plan-quote">
            <Row k="Current plan" v={`${q.current_plan_name || "—"}${q.current_interval ? ` · ${q.current_interval}` : ""}`} id="quote-current-plan" />
            <Row k="New plan" v={q.plan_name} id="pay-plan-name" bold />
            <Row k="Billing period" v={q.billing_interval === "annual" ? "Annual (365 days)" : "Monthly (30 days)"} id="quote-interval" />
            <Row k="Price" v={inr(q.base_amount)} id="quote-base" />
            <Row k={`GST (${q.gst_rate}%)`} v={inr(q.tax_amount)} id="quote-tax" />
            <div className="border-t border-slate-100 pt-2"><Row k="Total payable" v={inr(q.total_amount)} id="pay-plan-amount" bold /></div>
            <p className="rounded-lg bg-slate-50 p-2.5 text-xs text-slate-500" data-testid="quote-policy">{q.effective_policy}</p>
          </div>
        )}
        <DialogFooter>
          <Button variant="outline" onClick={onCancel} disabled={busy} data-testid="pay-cancel-btn">Cancel</Button>
          <Button className="bg-slate-900 text-white" data-testid="pay-now-btn" disabled={busy || !q} onClick={onPay}>{busy ? "Opening…" : q ? `Pay ${inr(q.total_amount)}` : "Pay"}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
